appComum.service("emissorService", emissorService);

emissorService.$inject = ["$http"];
function emissorService($http) {
  /**
   * Emissor enum
   */
  const emissorEnum = Object.freeze({
    VRPAT: "VRPAT", // PAT
    VRGPA: "VRGPA", // GPA
    JVCEF: "JVCEF", // Caixa Pré-pagos
    PATCEF: "PATCEF", // Caixa Cartões
  });

  /**
   * Emissor code map
   */
  const emissorUrl = {
    vr: {
      code: emissorEnum.VRPAT,
      origin_code: null,
    },
    multibeneficiosgpa: {
      code: emissorEnum.VRGPA,
      origin_code: null,
    },
    caixaprepagos: {
      code: emissorEnum.JVCEF,
      origin_code: null,
    },
    portalcaixacartoes: {
      code: emissorEnum.PATCEF,
      origin_code: emissorEnum.JVCEF,
    },
  };

  /**
   * Resgata a lista de campanhas da API
   *
   * NOTE: O atributo "restricaoPedidos" Restringe para apenas os produtos do array de produtos.
   * @returns
   */
  function getEmissor() {
    return new Promise((resolve, reject) => {
      // NOTE: Este é o código real acessando um endpoint fornecido pelo backend.
      // Deve ser ativado assim que o endpoint for disponibilizado para uso em produção.
      /*
      $http({
        method: "GET",
        url: `/api-web/rh/parametrizacoes/emissor/${getSiglaEmissor()}`,
      })
      .then(
        (response) => {
          if(response.status !== 200) {
            return reject(response);
          }

          constants.DYNAMIC_DATA.EMISSOR = response.data;
          resolve(response.data);
        },
        (error) => {
          console.error(`getEmissor() | Error '${error.status}': ${error.data.message}`);
          reject(error);
        }
      );
      */

      // NOTE: Solução estática PALIATIVA:
      $http({
        method: "GET",
        url: `/portal/app/UI-RH/static-data/emissor.json`,
      }).then(
        (response) => {
          let data = {};

          if (response.status !== 200) {
            return reject(response);
          }

          data = response.data[getSiglaEmissor()];
          constants.DYNAMIC_DATA.EMISSOR = data;

          resolve(data);
        },
        (error) => {
          console.error(`getEmissor() | Error '${error.status}': ${error.data.message}`);
          reject(error);
        }
      );
    });
  }

  /**
   * Retorna o código do emissor definido no cookie 'lumUserLogin'
   *
   * @returns String com o código do emissor
   */
  function getSiglaEmissor() {
    if (constants.SETTINGS.SIGLA_EMISSOR) {
      return constants.SETTINGS.SIGLA_EMISSOR;
    }

    const emissorData = getEmissorSiglaByURL();

    if (!emissorData) {
      throw new Error("Sigla emissor não encontrado no cookie!");
    }

    constants.SETTINGS.SIGLA_EMISSOR = emissorData.origin_code ? emissorData.origin_code : emissorData.code;

    return constants.SETTINGS.SIGLA_EMISSOR;
  }

  /**
   * Identificação do código emissor pela URL
   * TODO: Esta lógica deve ser fornecida pelo backend.
   * @returns sigla Emissor
   */
  function getEmissorSiglaByURL() {
    try {
      const hostname = window.location.hostname;

      if (hostname === "localhost") {
        return emissorUrl.vr;
      }

      return emissorUrl[Object.keys(emissorUrl).find((key) => hostname.indexOf(key) > -1)];
    } catch (error) {
      console.error("getEmissorSiglaByURL: ", error);
      return undefined;
    }
  }

  /**
   * Define uma sigla de emissor.
   */
  function setSiglaEmissor(sigla) {
    constants.SETTINGS.SIGLA_EMISSOR = sigla;
  }

  /**
   * Devolve os links de redirecionamento por emissor.
   *
   * @returns Data com os redirecionamentos personalizados
   */
  function redirect() {
    const { prefixoUrl } = constants.DYNAMIC_DATA.EMISSOR;
    const complemento = getSiglaEmissor() === emissorEnum.VRPAT ? "vr-e-" : "";
    const url = `/portal/${prefixoUrl}/area-restrita/${complemento}empresas`;

    return {
      empresas: {
        principal: url,
        selecao: `${url}/empresas.html`,
        cadastrosConsultas: `${url}/cadastros-e-consultas.html`,
      },
    };
  }

  return {
    getEmissor: getEmissor,
    getData: () => constants.DYNAMIC_DATA.EMISSOR,
    setSiglaEmissor: setSiglaEmissor,
    redirect: redirect,
    getSigla: getSiglaEmissor,
    sigla: getSiglaEmissor(),
    data: constants.DYNAMIC_DATA.EMISSOR,
    i18n: () => getEmissorSiglaByURL().code,
  };
}
